module.exports = __webpack_public_path__ + "img/pazzle.png?9fed6d9f6a52cdf0ce0bc4820d5c1689";